module.exports = __webpack_public_path__ + "static/img/MATIAS_PRADO.74278a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/MATIAS_PRADO.jpg
// module id = aa5y
// module chunks = 1